module.exports = __webpack_public_path__ + "static/media/scrape.b1577ed4.jpg";